export default __webpack_public_path__ + "static/media/inactive-mood.c467ff8f.svg";